import { render, staticRenderFns } from "./errorfindmyphone.vue?vue&type=template&id=12750cbc"
import script from "./errorfindmyphone.vue?vue&type=script&lang=js"
export * from "./errorfindmyphone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Repos\\StopRiparo_Piattaforma\\Piattaforma.Client\\wwwroot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12750cbc')) {
      api.createRecord('12750cbc', component.options)
    } else {
      api.reload('12750cbc', component.options)
    }
    module.hot.accept("./errorfindmyphone.vue?vue&type=template&id=12750cbc", function () {
      api.rerender('12750cbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ticket/views/errorfindmyphone.vue"
export default component.exports